var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.14307 1.2793L10.8032 10.9395L1.14307 20.5996","stroke":"white","strokeWidth":"2"}));
}

ChevronRight.defaultProps = {"width":"13","height":"22","viewBox":"0 0 13 22","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
